import { Outlet } from 'react-router-dom'

export default function AuthRoutes(): JSX.Element | null {
  return <Outlet />
}
